import { render, staticRenderFns } from "./RmpDetailsSubheaderLoader.vue?vue&type=template&id=3b335c4d&scoped=true"
import script from "./RmpDetailsSubheaderLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDetailsSubheaderLoader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b335c4d",
  null
  
)

export default component.exports